import React from 'react';
import { BrowserRouter, Route, HashRouter, Switch, Redirect } from "react-router-dom";
import Navbar from './components/layout/Navbar';
import * as ROUTES from './constants/routes';
import { connect } from 'react-redux';

/// ROUTES
import Landing from './components/landing/Landing';
import DashboardProjects from './components/dashboard/subpages/DashboardProjects';
import ProjectDashboard from './components/project/ProjectDashboard';
import DashboardFolders from './components/dashboard/subpages/DashboardFolders';
import ErrorPage from './components/error/ErrorPage';
import RegistrationPage from './components/auth/RegistrationPage';
import LoginPage from './components/auth/LoginPage';
import CreateProjectPage from './components/project/addAndJoin/addProject/CreateProjectPage';
import JoinProjectPage from './components/project/addAndJoin/joinProject/JoinProjectPage';
import MyProfile from './components/myProfile/MyProfile';
import DashboardCompany from './components/dashboard/subpages/DashboardCompany';
import HomeLanding from './components/landing/HomeLanding';
import VerifyEmailPage from './components/auth/VerifyEmailPage';
import ResetPasswordPage from './components/auth/ResetPasswordPage';
import About from './components/landing/About';
import Contact from './components/landing/Contact';
import Docs from './components/landing/Docs';
import Team from './components/landing/Team';
import FloorPage from './components/maps/floorSketch/FloorPage';
import ElevationPage from './components/maps/elevationSketch/ElevationPage';
import CreateCompanyPage from './components/company/CreateCompanyPage';
import ImageZoomPanPich from './components/landing/ImageZoomPanPich';
import ZoomPanPinch from './components/landing/ZoomPanPinch';
import Pricing from './components/landing/Pricing';
import PagniationTesting from './components/landing/PagniationTesting';
import ProjectPageLanding from './components/project/ProjectPageLanding';
import IndividualProduct from './components/landing/pricing/IndividualProduct'
import IndividualConsumable from './components/landing/pricing/IndividualConsumable';


const App = (props) => {
  const { isSignedIn } = props;
  const divClassName = isSignedIn ? "App" : "UnSignedInApp"
  return (
    <BrowserRouter>
      <div className={divClassName}>

        <Navbar />

        {/* MAIN PAGES */}
        <Route exact path={ROUTES.LANDING} component={Landing} />
        <Route exact path={ROUTES.ABOUT} component={About} />
        <Route exact path={ROUTES.CONTACT} component={Contact} />
        <Route exact path={ROUTES.DOCS} component={Docs} />
        <Route exact path={ROUTES.TEAM} component={Team} />
        <Route path={ROUTES.PRICING} component={Pricing} />

        {/* AUTH - LOGIN, REGISTER, LOST PASS */}
        <Route exact path={ROUTES.SIGN_IN} component={LoginPage} />
        <Route exact path={ROUTES.SIGN_UP} component={RegistrationPage} />
        <Route exact path={ROUTES.VERIFY_ACCOUNT} component={VerifyEmailPage} />
        <Route exact path={ROUTES.FORGOT_PASS} component={ResetPasswordPage} />

        {/* HOME - DASHBOARD */}
        <Route path={ROUTES.HOME} component={HomeLanding} />
        <Route exact path={ROUTES.HOME_PROJECTS} component={DashboardProjects} />
        <Route exact path={ROUTES.HOME_COMPANY} component={DashboardCompany} />
        <Route exact path={ROUTES.HOME_FOLDERS} component={DashboardFolders} />
        <Route exact path={ROUTES.HOME_CREATE_PROJECT} component={CreateProjectPage} />
        <Route exact path={ROUTES.HOME_JOIN_PROJECT} component={JoinProjectPage} />
        <Route exact path={ROUTES.USER_PROFILE} component={MyProfile} />
        <Route exact path={ROUTES.CREATE_NEW_COMPANY} component={CreateCompanyPage} />

        {/* PROJECT DASHBOARD */}
        <Route path={ROUTES.IND_PROJECT} component={ProjectPageLanding} />
        <Route exact path={ROUTES.IND_PROJECT_DASHBOARD} component={ProjectDashboard} />
        <Route exact path={ROUTES.IND_PROJECT_FLOOR_MAP_EDITOR} component={FloorPage} />
        <Route exact path={ROUTES.IND_PROJECT_ELEVATION_MAP_EDITOR} component={ElevationPage} />
        <Route exact path={ROUTES.HOME_IMAGE} component={ZoomPanPinch} />
        <Route path={ROUTES.IND_PRODUCT} component={IndividualProduct} /> 
        <Route path={ROUTES.IND_CONSUMABLE} component={IndividualConsumable} /> 
        {/* <Route exact path={ROUTES.IND_PROJECT_REGIONS} component={ErrorPage} /> */}

        {/* ERROR */}
        {/* <Route path='*' component={ErrorPage} /> */}
      </div>
    </BrowserRouter>
  );
}

const mapStateToProps = (state) => {
  return {
    isSignedIn: !state.firebase.auth.isEmpty,
  }
}

export default connect(mapStateToProps)(App);